// extracted by mini-css-extract-plugin
export default {"next-piece":"nextPiece_next-piece__gle-0","piece":"nextPiece_piece__YhFsp"};